import React from "react";
import { Link } from "react-router-dom";
import { Link as LinkScroll } from "react-scroll";
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles({
  scroll: {
    margin: '0 !important',
    fontSize: 16,
    whiteSpace: 'nowrap',
    padding: '8px 30px 8px 0',
    '@media screen and (max-width: 520.98px)': {
      padding: '8px 170px 8px 0',
    }
  },
  link: {
    margin: '0 !important',
    fontSize: 16,
    whiteSpace: 'nowrap',
    padding: '8px 30px 8px 0',
    '@media screen and (max-width: 520.98px)': {
      padding: '8px 170px 8px 0',
    }
  }
})

const getOffset = window.innerWidth < 1360 ? -54:0;

function About({ sections }) {

  const classes = useStyles()

  return (
    <div className="AboutF">
      <p className="AboutF_title">Acerca de</p>
      <div className='AboutF_container'>
        {sections.map((section, index)=>{
          return section.link==='scroll' ?
          <LinkScroll
            key={index}
            to={section.to}
            smooth="true"
            duration={500}
            delay={100}
            offset={getOffset}
            className={classes.scroll}
          >
            {section.name}
          </LinkScroll> :
          <Link
            to={section.to}
            className={classes.link}
          >
            {section.name}
          </Link>
        })}
      </div>
      {/* <LinkScroll to="about" smooth="true" duration={500} delay={100} offset={getOffset}>
        Quiénes somos
      </LinkScroll>
      <LinkScroll to="benefits" smooth="true" duration={500} delay={100} offset={getOffset}>
        Beneficios
      </LinkScroll>
      <LinkScroll to="sign-up" smooth="true" duration={500} delay={100} offset={getOffset}>
        Regístrate
      </LinkScroll>
      <LinkScroll to="how" smooth="true" duration={500} delay={100} offset={getOffset}>
        Cómo funciona
      </LinkScroll>
      <LinkScroll to="community" smooth="true" duration={500} delay={100} offset={getOffset}>
        Comunidad
      </LinkScroll> */}
    </div>
  );
}

export default About;
